
    (function() {
      'use strict';
      
      const CSS = `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  --main-color: #e6c626;
  --secondary-color: #a08604;
}

.modal-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal-overlay.active {
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-newsletter .modal {
  background: white;
  border-radius: 16px;
  padding: 40px;
  max-width: 500px;
  height: max-content;
  width: 100%;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.4s ease;
}

.modal-newsletter .close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.modal-newsletter .close-btn:hover {
  background: #f5f5f5;
  color: #333;
}

.modal-newsletter .modal-content {
  text-align: center;
}

.modal-newsletter .modal-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  line-height: 1.3;
}

.modal-newsletter .modal-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
}

.modal-newsletter .form-group {
  margin-bottom: 20px;
}

.modal-newsletter .email-input {
  width: 100%;
  padding: 15px 20px;
  font-size: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s;
}

.modal-newsletter .email-input:focus {
  border-color: var(--main-color);
}

.modal-newsletter .submit-btn {
  width: 100%;
  padding: 15px;
  font-size: 16px;
  font-weight: 600;
  background: linear-gradient(135deg, var(--main-color) 0%, var(--secondary-color) 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  transform: scale(1);
}

.modal-newsletter .submit-btn:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.modal-newsletter .submit-btn:active {
  transform: scale(0.95);
}

.modal-newsletter .submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.modal-newsletter .submit-btn:disabled:hover {
  transform: scale(1);
}

.modal-newsletter .success-content {
  display: none;
}

.modal-newsletter .success-content.active {
  display: block;
}

.modal-newsletter .coupon-box {
  background: #f8f9fa;
  border: 2px dashed var(--main-color);
  border-radius: 8px;
  padding: 20px;
  margin-top: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-newsletter .coupon-code {
  font-size: 24px;
  font-weight: 700;
  color: var(--secondary-color);
  letter-spacing: 2px;
}

.modal-newsletter .copy-btn {
  background: var(--main-color);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  font-size: 18px;
}

.modal-newsletter .copy-btn:hover {
  background: #5568d3;
}

.modal-newsletter .copy-btn.copied {
  background: #10b981;
}

.modal-newsletter .error-message {
  color: #ef4444;
  font-size: 14px;
  margin-top: 10px;
  display: none;
}

.modal-newsletter .error-message.active {
  display: block;
}

.modal-newsletter .loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
`;
      const HTML = `<div class="modal-overlay modal-newsletter" id="modalOverlay">
      <div class="modal">
        <button class="close-btn" onclick="closeModal()">&times;</button>

        <!-- Contenido inicial: Formulario -->
        <div class="modal-content" id="formContent">
          <h2 class="modal-title">5% de descuento para la primera compra</h2>
          <p class="modal-description">
            Suscríbete a nuestro newsletter y recibe un 5% de descuento en toda la tienda en tu primera compra.
          </p>

          <form id="newsletterForm">
            <div class="form-group">
              <input type="email" class="email-input" id="emailInput" placeholder="tu@email.com" required />
            </div>
            <button type="submit" class="submit-btn" id="submitBtn">5% de descuento</button>
            <div class="error-message" id="errorMessage"></div>
          </form>
        </div>

        <!-- Contenido de éxito -->
        <div class="success-content" id="successContent">
          <h2 class="modal-title">¡Gracias por unirte!</h2>
          <p class="modal-description">
            Ya puedes usar el cupón de 5% en tu primera compra. Esperamos que lo disfrutes.
          </p>

          <div class="coupon-box">
            <span class="coupon-code" id="couponCode">WELCOME15</span>
            <button class="copy-btn" onclick="copyCoupon()" id="copyBtn">📋</button>
          </div>
        </div>`;

      if (!document.getElementById('geeparts-newsletter-styles')) {
        const style = document.createElement('style');
        style.id = 'geeparts-newsletter-styles';
        style.textContent = CSS;
        document.head.appendChild(style);
      }

      function init() {
        if (!document.getElementById('modalOverlay')) {
          document.body.insertAdjacentHTML('beforeend', HTML);
        }

        // ============================================
// CONFIGURACIÓN DEL WIDGET
// ============================================
const defaultConfig = {
  autoOpen: true,
  autoOpenDelay: 3000,
  couponCode: 'WELCOME5',
  listId: 12,
}

// Merge con configuración del usuario
const config = Object.assign({}, defaultConfig, window.geepartsNewsletterConfig || {})

// ============================================
// CONFIGURACIÓN DE BREVO
// ============================================
const BREVO_CONFIG = {
  listId: config.listId,
  apiUrl: 'https://api.brevo.com/v3/contacts',
}

// ============================================
// FUNCIONES DEL MODAL
// ============================================
function openModal() {
  document.getElementById('modalOverlay').classList.add('active')
}

function closeModal() {
  document.getElementById('modalOverlay').classList.remove('active')
  // Reiniciar el modal después de cerrar
  setTimeout(() => {
    resetModal()
  }, 300)
}

function resetModal() {
  document.getElementById('formContent').style.display = 'block'
  document.getElementById('successContent').classList.remove('active')
  document.getElementById('newsletterForm').reset()
  document.getElementById('errorMessage').classList.remove('active')
  document.getElementById('submitBtn').disabled = false
}

// Cerrar modal al hacer clic fuera de él
document.getElementById('modalOverlay').addEventListener('click', function (e) {
  if (e.target === this) {
    closeModal()
  }
})

// ============================================
// FUNCIÓN PARA COPIAR CUPÓN
// ============================================
function copyCoupon() {
  const couponCode = document.getElementById('couponCode').textContent
  const copyBtn = document.getElementById('copyBtn')

  navigator.clipboard.writeText(couponCode).then(() => {
    copyBtn.textContent = '✓'
    copyBtn.classList.add('copied')

    setTimeout(() => {
      copyBtn.textContent = '📋'
      copyBtn.classList.remove('copied')
    }, 2000)
  })
}

// ============================================
// INTEGRACIÓN CON BREVO
// ============================================
async function addContactToBrevo(email) {
  const WORKER_URL = 'https://shy-fire-438e.jandreys15.workers.dev'

  try {
    const response = await fetch(WORKER_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        listId: BREVO_CONFIG.listId,
      }),
    })

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.error || 'Error al suscribir')
    }

    return data
  } catch (error) {
    console.error('Error al suscribir:', error)
    throw error
  }
}

// ============================================
// MANEJO DEL FORMULARIO
// ============================================
document.getElementById('newsletterForm').addEventListener('submit', async function (e) {
  e.preventDefault()

  const emailInput = document.getElementById('emailInput')
  const submitBtn = document.getElementById('submitBtn')
  // const errorMessage = document.getElementById('errorMessage')
  const email = emailInput.value.trim()

  if (!email || !isValidEmail(email)) {
    showError('Por favor, ingresa un email válido')
    return
  }

  // Deshabilitar botón y mostrar loading
  submitBtn.disabled = true
  submitBtn.innerHTML = '<span class="loading"></span>'

  try {
    const result = await addContactToBrevo(email)

    const { message, success, duplicate } = result

    if (!success) {
      throw new Error(result.message || 'Error al suscribir')
    }

    if (duplicate) {
      showSuccess({ message, duplicate })
      localStorage.setItem('newsletterSubmitted', 'true')
      return
    }

    showSuccess({ message })
    localStorage.setItem('newsletterSubmitted', 'true')
  } catch (error) {
    console.error('Error:', error)
    showError('Hubo un error al procesar tu suscripción. Por favor, intenta de nuevo.')
    submitBtn.disabled = false
    submitBtn.textContent = '5% de descuento'
  }
})

function isValidEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return regex.test(email)
}

function showError(message) {
  const errorMessage = document.getElementById('errorMessage')
  errorMessage.textContent = message
  errorMessage.classList.add('active')

  setTimeout(() => {
    errorMessage.classList.remove('active')
  }, 3000)
}

function showSuccess({ message, duplicate = false }) {
  const couponElement = document.getElementById('couponCode')
  const couponBox = document.querySelector('.coupon-box')
  const successTitle = document.querySelector('#successContent .modal-title')

  if (duplicate) {
    const successTitle = document.querySelector('#successContent .modal-title')
    if (successTitle) {
      successTitle.textContent = message
    }

    if (couponBox) {
      couponBox.style.display = 'none'
    }
  } else {
    if (couponElement && config.couponCode) {
      couponElement.textContent = config.couponCode
    }

    if (message && successTitle) {
      successTitle.textContent = message
    }
  }

  document.getElementById('formContent').style.display = 'none'
  document.getElementById('successContent').classList.add('active')
}

// ============================================
// AUTO-ABRIR MODAL
// ============================================
if (config.autoOpen && !localStorage.getItem('newsletterSubmitted')) {
  setTimeout(() => {
    openModal()
  }, config.autoOpenDelay)
}


        window.openModal = openModal;
        window.closeModal = closeModal;
        window.copyCoupon = copyCoupon;
        
        window.geepartsNewsletter = {
          config: config,
          openModal: openModal,
          closeModal: closeModal,
        };
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();
    